import React, { useState, useEffect, useContext, useRef } from "react";
import {FormattedMessage, useIntl} from 'react-intl';
import { RouteContext } from "../../../contexts/route.context";
import { Modal, Button} from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from "axios";

import visalogoC from "../../../assets/images/visa-cropped.png";
import visalogo from "../../../assets/images/visa.png";
import masterlogo from "../../../assets/images/mc_symbol.svg";
import madalogo from "../../../assets/images/Mada_Logo.svg";

const Payments = () => {
    const intl = useIntl();
    const { me, baseURLPayment, baseURL, apiHeaders } = useContext(RouteContext);
    const [showModalPaymentMada, setShowModalPaymentMada] = useState("");
    const [showModalPaymentMaster, setShowModalPaymentMaster] = useState("");
    const [showModalPaymentVisa, setShowModalPaymentVisa] = useState("");
    const [showModalPaymentMethod, setShowModalPaymentMethod] = useState(false);
    const [showModalPaymentDeleteCard, setShowModalPaymentDeleteCard] = useState(false);
    const [myCards, setMyCards] = useState()
    

    function Iframe(props) {
        return (
            <div
            className="p-3"
            dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
            />
        );
    }

    useEffect(()=>{
        setMyCards(me.cards)
    },[])

    const handleCloseModalPaymentMethod = () => setShowModalPaymentMethod(false);
    const handleCloseModalPaymentMethodMada = () => setShowModalPaymentMada(false);
    const handleCloseModalPaymentMethodMaster = () => setShowModalPaymentMaster(false);
    const handleCloseModalPaymentMethodVisa = () => setShowModalPaymentVisa(false);
    // const handleCloseModalPaymentDeleteCard = () => setShowModalPaymentDeleteCard(false);

    let iframePaymentVisa = {
        payment:
          `<iframe padding="20px" width="100%" height="650" scrolling="no" frameborder="no" allow="autoplay" src=${baseURLPayment}/charge-card-register?token=${process.env.REACT_APP_RENTER_PAYMENT_TOKEN}&user_id=${me.id}&app_used=web&status=success&brand=VISA></iframe>`      
    };
    let iframePaymentMada = {
    payment:
        `<iframe padding="20px"  width="100%" height="650" scrolling="no" frameborder="no" allow="autoplay" src=${baseURLPayment}/charge-card-register?token=${process.env.REACT_APP_RENTER_PAYMENT_TOKEN}&user_id=${me.id}&app_used=web&status=success&brand=MADA></iframe>`      
    };
    let iframePaymentMaster = {
    payment:
        `<iframe padding="20px"  width="100%" height="650" scrolling="no" frameborder="no" allow="autoplay" src=${baseURLPayment}/charge-card-register?token=${process.env.REACT_APP_RENTER_PAYMENT_TOKEN}&user_id=${me.id}&app_used=web&status=success&brand=MASTER></iframe>`      
    };

    const deleteMyCard = async (id) => {
        console.log(id)
        let x = await axios({
            url: baseURL,
            headers: apiHeaders,
            method: "post",
            data: {
              query: `
                mutation {
                  deleteCard(id: "${id}"){
                    status
                  }
                }
              `
            }
          });

          if(x.data.data){
            const updatedItems = me.cards.filter(item => item.id !== id)
            setMyCards(updatedItems)
            console.log(x, "T")
          }
          else{
            // window.location.reload();
            console.log(x, "S")
          }
    }

    return(
        <>
            <div className="payment-container">
                <div className="payment-card-container">
                    {myCards?.map((card, index)=>{
                        return(
                            <div key={index} className={`payment-card`} onClick={()=>{
                                Swal.fire({
                                    title: 'Are you sure you want to delete Card?',
                                    text: "",
                                    icon: 'question',
                                    showDenyButton: true,
                                    confirmButtonColor: '#FF5833',
                                    confirmButtonText: 'Delete',
                                    denyButtonColor: '#AAAAAA',
                                    denyButtonText: 'Cancel'
                                }).then((e) => {
                                    // setShowModalIban(false);
                                    if (e.isConfirmed) {
                                        // console.log("Go")
                                        deleteMyCard(card.id)
                                    }
                                });
                            }}>
                                <div className="payment-top">
                                    <div>
                                        {
                                            card.paymentBrand.toLowerCase() === "visa" ?
                                            <img className={"paymentLogo"} src={visalogoC}/>
                                            :

                                            card.paymentBrand.toLowerCase() === "mada" ?
                                                <img className={"paymentLogo"} src={madalogo}/>
                                            :

                                            card.paymentBrand.toLowerCase() === "master" ?
                                                <img className={"paymentLogo"} src={masterlogo}/>
                                            :

                                            null
                                        }
                                        
                                    </div>
                                </div>
                                <div className="payment-middle">
                                    <div>
                                    {`**** **** **** ${card?.last_4_digits}`}
                                    </div>
                                </div>
                                <div className="payment-bottom">
                                    <div>
                                        <p className="payment-bottom-name-on-card">
                                            {`Name on Card`}
                                        </p>
                                        <div className="payment-bottom-holder">
                                            {card?.holder?.toUpperCase()}
                                        </div>
                                    </div>
                                    <div>
                                        <p className="payment-bottom-name-on-card">
                                            {`Valid Thru`}
                                        </p>
                                        <div className="payment-bottom-holder">
                                            {`${card?.expiryMonth}/${card?.expiryYear}`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {/* {
                        myCards?.length === 0 &&
                        <div className="d-flex justify-content-center cgray">
                            <FormattedMessage 
                            id="nosavedcards.textt"
                            defaultMessage="No saved card"
                            description="No saved card"
                        />
                        </div>
                    } */}

                   
                    
                </div> 
                <div className="linkcardbutton" onClick={()=>setShowModalPaymentMethod(true)}>
                    <FormattedMessage 
                        id="linkcard.text"
                        defaultMessage="Link Card"
                        description="Link Card"
                    />
                </div>
            </div>
            
            <Modal className="modalChat" show={showModalPaymentMethod} onHide={handleCloseModalPaymentMethod}>
                <Modal.Body className="card-choices">
                <div className="card-choices-item" onClick={()=>{
                    setShowModalPaymentMada(true)
                }}>
                        <img className={"paymentLogo"} src={madalogo}/>
                        <div className="mx-2"></div>
                        <div>
                            Mada
                        </div>
                </div>
                <div className="card-choices-item" onClick={()=>{
                    setShowModalPaymentVisa(true)
                }}>
                        <img className={"visapaymentLogo"} src={visalogo}/>
                        <div className="mx-2"></div>
                        <div>
                            Visa
                        </div>
                </div>
                <div className="card-choices-item" onClick={()=>{
                    setShowModalPaymentMaster(true)
                }}>
                        <img className={"paymentLogo"} src={masterlogo}/>
                        <div className="mx-2"></div>
                        <div>
                            Master
                        </div>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button style={{background: "#FF5833", borderColor: "#FF5833"}} onClick={handleCloseModalPaymentMethod}>Close</Button>
                </Modal.Footer>
            </Modal>

            <Modal className="modalChat" show={showModalPaymentMada} onHide={handleCloseModalPaymentMethodMada}>
                <Modal.Body className="p-0">
                    <Iframe iframe={iframePaymentMada["payment"]} allow="autoplay"/>
                </Modal.Body>
            </Modal>

            <Modal className="modalChat" show={showModalPaymentMaster} onHide={handleCloseModalPaymentMethodMaster}>
                <Modal.Body className="p-0">
                    <Iframe iframe={iframePaymentMaster["payment"]} allow="autoplay"/>
                </Modal.Body>
            </Modal>

            <Modal className="modalChat" show={showModalPaymentVisa} onHide={handleCloseModalPaymentMethodVisa}>
                <Modal.Body className="p-0">
                    <Iframe iframe={iframePaymentVisa["payment"]} allow="autoplay"/>
                </Modal.Body>
            </Modal>
            
        </>
        
        
    )
}

export default Payments;